// Client-side helper for the /api/sappa/:address Function.
//
// During `vite dev` (port 5173) this endpoint isn't available; run
// `wrangler pages dev` for the full flow. The UI handles a 404 gracefully.

export async function lookupSappa(address) {
  if (!address || !address.trim()) throw new Error('enter an address');
  const url = `/api/sappa/${encodeURIComponent(address.trim())}`;
  const res = await fetch(url);
  if (!res.ok) {
    if (res.status === 404) throw new Error('SAPPA endpoint not available — run `wrangler pages dev` instead of `vite dev`');
    const body = await res.text();
    throw new Error(`SAPPA ${res.status}: ${body.slice(0, 200)}`);
  }
  return res.json();
}
